var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "scrollDiv",
      class: ["infinite-scroller", _vm.classList],
      style: _vm.maxHeight && {
        "max-height": `${_vm.maxHeight}`
      }
    },
    [
      _vm._t("scrollDiv"),
      _c(
        "portal",
        {
          attrs: {
            disabled: _vm.portalDisabled,
            slim: true,
            to: _vm.loaderPortalTarget
          }
        },
        [
          _vm.initialMoreData &&
          (_vm.loading || !_vm.moreData) &&
          !_vm.scrollingUp
            ? _c(
                "div",
                {
                  staticClass: "infinite-scroller__container-elements",
                  attrs: { "data-testid": "endResultContainer" }
                },
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "infinite-scroller__loading" },
                        [_c("Loader", { attrs: { variant: "dots" } })],
                        1
                      )
                    : _vm._e(),
                  !_vm.moreData
                    ? _c(
                        "div",
                        { staticClass: "infinite-scroller__end-result" },
                        [
                          _c(
                            "span",
                            { staticClass: "infinite-scroller__text" },
                            [
                              _vm._v(
                                " No more " + _vm._s(_vm.objectTypeName) + ". "
                              )
                            ]
                          ),
                          _vm.showEndResultImg
                            ? _c("img", {
                                staticClass: "infinite-scroller__img",
                                attrs: {
                                  src: _vm.endResultsSvg,
                                  alt: "End of Results Graphic - Road Sign"
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }